import {Dispatch} from 'redux';
import * as actions from './actionTypes';
import {IItem} from '../../Interfaces';

const apiUrl =
  'https://us-central1-tasteexperience-df61c.cloudfunctions.net';

export const cleanLocal = () => ({
  type: actions.LOCAL_CLEAN_UP,
});

export const cleanLocalComments = () => ({
  type: actions.LOCAL_CLEAN_COMMENTS,
});

export const paginate = (
  limit: number,
  barcode?: number,
  parameter?: string,
  lastValue?: string | number,
) => (dispatch: Dispatch) => {
  dispatch({type: actions.PAGINATE_START});
  const nextPage: string | null = barcode
    ? `&barcode=${barcode}&${[parameter]}=${lastValue}`
    : null;
  fetch(`${apiUrl}/paginate?limit=${limit}${nextPage}`)
    // fetch(
    //   `http://localhost:5001/tasteexperience-df61c/us-central1/paginate?limit=${limit}${nextPage}`,
    // )
    .then((response) => response.json())
    .then((data) =>
      dispatch({
        type: actions.PAGINATE_SUCCESS,
        payload: data,
      }),
    )
    .catch((error) => {
      dispatch({
        type: actions.PAGINATE_FAIL,
        payload: error.message,
      });
    });
};

export const getProduct = (id: string) => (
  dispatch: Dispatch,
) => {
  dispatch({type: actions.GET_PRODUCT_START});
  fetch(`${apiUrl}/getProduct?id=${id}`, 
  {headers: {'Cache-Control': 'public, max-age=120'}})
    .then((response) => response.json())
    .then((data) =>
      dispatch({
        type: actions.GET_PRODUCT_SUCCESS,
        payload: data,
      }),
    )
    .catch((error) => {
      console.log(error);
      dispatch({
        type: actions.GET_PRODUCT_FAIL,
        payload: error.message,
      });
    });
};

export const addComment = (comment: any) => (
  dispatch: Dispatch,
) => {
  dispatch({type: actions.ADD_COMMENT_START});
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(comment),
  };

  fetch(`${apiUrl}/addComment`, options)
    .then((response) => response.json())
    .then((data) =>
      dispatch({
        type: actions.ADD_COMMENT_SUCCESS,
        payload: {data, comment},
      }),
    )
    .catch((error) => {
      console.log(error);
      dispatch({
        type: actions.ADD_COMMENT_FAIL,
        payload: error.message,
      });
    });
};

export const paginateComments = (
  id: string,
  limit: number,
) => (dispatch: Dispatch) => {
  dispatch({type: actions.PAGINATE_COMMENT_START});

  fetch(
    `${apiUrl}/paginateProductComments?id=${id}&limit=${limit}`,
  )
    .then((response) => response.json())
    .then((data) =>
      dispatch({
        type: actions.PAGINATE_COMMENT_SUCCESS,
        payload: data,
      }),
    )
    .catch((error) => {
      console.log(error);
      dispatch({
        type: actions.PAGINATE_COMMENT_FAIL,
        payload: error.message,
      });
    });
};

// @ts-ignore
export const productVote = (data) => (dispatch) => {
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  };
  // @ts-ignore
  fetch(`${apiUrl}/productVote`, options)
    // @ts-ignore
    .then((response) => response.json())
    // @ts-ignore
    .catch((error) => {
      console.log(error);
    });
};
